module.exports = __webpack_public_path__ + "img/employee.1ca4a7c0.svg";